/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Imagesreplacecover2Inputs */

const en_imagesreplacecover2 = /** @type {(inputs: Imagesreplacecover2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replace cover`)
};

const de_imagesreplacecover2 = /** @type {(inputs: Imagesreplacecover2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titelbild ersetzen`)
};

/**
* | output |
* | --- |
* | "Replace cover" |
*
* @param {Imagesreplacecover2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const imagesreplacecover2 = /** @type {((inputs?: Imagesreplacecover2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Imagesreplacecover2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_imagesreplacecover2(inputs)
	return de_imagesreplacecover2(inputs)
});
export { imagesreplacecover2 as "imagesReplaceCover" }